module.exports = __webpack_public_path__ + "static/Often_Asked_Ingredie-fcc609d13e9b6549291bd62e0a60078a.png";